import {createContext, useContext, useReducer} from "react";
import TextSection from "../components/TextSection";
import {ConfigContext} from "./ConfigContext";
import {convertMMtoPx, convertMMtoPxWithScaling} from "../services/helpers";
import {WorkingSizeContext} from "./WorkingSizeContext";

const initData = []
export const TextSectionsListContext = createContext(null);
export const TextSectionsDispatch = createContext(null);

export const TextSectionsListProvider = ({children}) => {
    const configContext = useContext(ConfigContext);
    const workingSizeContext = useContext(WorkingSizeContext);

    const [textSections, dispatch] = useReducer(
        (state, action) => TextSectionsReducer(state, action, configContext, workingSizeContext),
        initData
    )
    return (
        <TextSectionsListContext.Provider value={textSections}>
            <TextSectionsDispatch.Provider value={dispatch}>
                {children}
            </TextSectionsDispatch.Provider>
        </TextSectionsListContext.Provider>
    )
}

function TextSectionsReducer(textSections, action, configContext, workingSizeContext) {

    switch (action.type) {
        case "set":
            return action.payload;
        case "addTextSection":
            const addFontSizeErpId = action.payload.fontSizeErpId
                || configContext.fontsSizesList?.find(f => f.font_size.slug === action.payload.fontSizeValue)?.font_size?.id_erp
                || configContext.selectedFontSizeObject?.id_erp;
            return [
                ...textSections,
                {
                    index: textSections.length,
                    position: {
                        x: action.payload.position.x,
                        y: action.payload.position.y
                    },
                    fontSize: action.payload.fontSize,
                    fontSizeValue: action.payload.fontSizeValue,
                    fontSizeErpId: addFontSizeErpId,
                    fontSizeValuePx : convertMMtoPx(action.payload.fontSizeValue),
                    fontSizeValuePxWithScaling : convertMMtoPxWithScaling(action.payload.fontSizeValue, workingSizeContext.scale),
                    letterSpacing: action.payload.letterSpacing,
                    value: action.payload.value,
                    rawContent: action.payload.rawContent,
                    active: action.payload.active,
                    textAlign: action.payload.textAlign,
                    //We need to load TextSection here, otherwise saved projects will not load text sections
                    content: <TextSection
                        index={textSections.length}
                        key={textSections.length}
                        value={action.payload.value}
                        defaultFontSize={action.payload.fontSize}
                        defaultLetterSpacing={action.payload.letterSpacing}
                        defaultPosition={{
                            x: action.payload.position.x,
                            y: action.payload.position.y
                        }}
                        rawValue={action.payload.rawContent}
                    />
                }
            ];

        case "updateTextSectionActive":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        active: action.payload.active,
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionPosition":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        position: action.payload.position,
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionData":
            return textSections.map((section, index) => {

                if (index === action.payload.index) {
                    return {
                        ...section,
                        value: action.payload.value,
                        rawContent: action.payload.rawContent,
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionFontSize":
            const updateFontSizeErpId = action.payload.fontSizeErpId
                || configContext.fontsSizesList?.find(f => f.font_size.slug === action.payload.fontSizeValue)?.font_size?.id_erp;
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        fontSizeValue: action.payload.fontSizeValue,
                        fontSize: action.payload.fontSizeName,
                        fontSizeErpId: updateFontSizeErpId || section.fontSizeErpId,
                        fontSizeValuePx: convertMMtoPx(action.payload.fontSizeValue),
                        fontSizeValuePxWithScaling: convertMMtoPxWithScaling(action.payload.fontSizeValue, workingSizeContext.scale),
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionLetterSpacing":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        letterSpacing: action.payload.letterSpacing,
                    }
                } else {
                    return section;
                }
            });
        case "removeTextSection":
            return textSections.filter((section, index) => index !== action.payload.index);
        case "resetTextSections":
            return [];
        case "deactivateAllTextSections":
            return textSections.map((section) => {
                return {
                    ...section,
                    active: false
                }
            });
        case "removeEmptyTextSections":
            return textSections.filter((section) => section.value !== '');
        case "updateTextSectionTextAlign":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        textAlign: action.payload.textAlign,
                    }
                } else {
                    return section;
                }
            });
        default:
            throw Error('Unknown action: ' + action.type);
    }
}